import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetEmployeeNcqaEnrollmentStatus"

export type NcqaEnrollmentResponse = {
  isEnrolled: boolean
}

export default function useGetNcqaEnrollment(
  employeeId: number
): UseQueryResult<NcqaEnrollmentResponse, ResponseError> {
  return useQuery<NcqaEnrollmentResponse, ResponseError>(
    [ENDPOINT, employeeId],
    () => client.getEmployeeNcqaEnrollmentStatus(employeeId),
    {
      ...RetryConfig
    }
  )
}
